import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link } from 'react-router-dom';
import styles from "./LineName.module.css";

// 이미지 자원
import downTriangleIcon from "../../img/icon/DownTriangleIcon.png";
import sideTriangleIcon from "../../img/icon/SideTriangleIcon.png";
import editImg from "../../img/common/editIcon.png";

// 모달 컴포넌트
import EditLineNameModal from "./editLineNameModal";

function LineName(props) {
    const [visibleFirst, setVisibleFirst] = useState(false);
    const [boxNum, setBoxNum] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [name, setName] = useState(props.name);

    // props.name이 외부에서 변경될 경우 로컬 상태와 동기화
    useEffect(() => {
        setName(props.name);
    }, [props.name]);

    // 박스별 데이터 카운트 API 호출
    const fetchBoxCount = useCallback(() => {
        const reqOption = {
            method: "post",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({
                Vessel: props.vessel,
                Line: props.name,
            })
        };

        fetch("/api/countBankingByBox", reqOption)
            .then((response) => response.json())
            .then(data => {
                setBoxNum(Array.isArray(data) ? data : []);
            })
            .catch(err => console.error("Box Count Fetch Error:", err));
    }, [props.vessel, props.name]);

    // 컴포넌트 마운트 시 또는 주요 props 변경 시 데이터 로드
    useEffect(() => {
        fetchBoxCount();
    }, [fetchBoxCount]);

    // 라인 이름 수정 핸들러
    const handleModalSubmit = (newText) => {
        const reqOption = {
            method: "post",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({
                vessel: props.vessel,
                newLineName: newText,
                lineName: props.name,
            })
        };

        fetch("/api/changeLineName", reqOption)
            .then((response) => response.json())
            .then(() => {
                setName(newText);
                setIsModalOpen(false); // 성공 시 모달 닫기 추가
            })
            .catch(error => {
                console.error('Change Line Name Error:', error);
            });
    };

    // 박스당 카운트 조회 함수
    const getCountForBox = (boxLabel) => {
        const boxData = boxNum.find(b => b.Box.toUpperCase() === boxLabel.toUpperCase());
        return boxData ? boxData.count : 0;
    };

    // 박스 리스트 렌더링 (13개 고정)
    const renderBoxes = useMemo(() => {
        if (!visibleFirst) return null;

        return Array.from({ length: 13 }, (_, index) => {
            const boxLabel = `BOX${index + 1}`;
            const count = getCountForBox(boxLabel);
            
            return (
                <div key={boxLabel} className={styles.box}>
                    <Link to={`/${props.vessel}/${props.name}/${boxLabel}`} className={styles.customLink}>
                        {boxLabel} ({count}/100)
                    </Link>
                </div>
            );
        });
    }, [visibleFirst, boxNum, props.vessel, props.name]);

    return (
        <div className={styles.lineNameMain}>
            {/* 토글 버튼 영역 */}
            <span className={styles.outlinePdo} onClick={() => setVisibleFirst(!visibleFirst)}>
                <img 
                    className={visibleFirst ? styles.minusImg_low : styles.plusImg_low} 
                    src={visibleFirst ? downTriangleIcon : sideTriangleIcon} 
                    alt={visibleFirst ? "Collapse" : "Expand"} 
                />
            </span>

            {/* 이름 표시 영역 */}
            <span className={styles.pdoName} onClick={() => setVisibleFirst(!visibleFirst)}>
                {name}
            </span>

            {/* 수정 아이콘 (권한 체크) */}
            {props?.authLevel >= 3 && (
                <img
                    src={editImg}
                    className={styles.lineNameEditImg}
                    onClick={() => setIsModalOpen(true)}
                    alt="Edit"
                />
            )}

            {/* 이름 수정 모달 */}
            <EditLineNameModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSubmit={handleModalSubmit}
                lineName={props.name}
            />

            {/* 박스 리스트 영역 */}
            {renderBoxes}
        </div>
    );
}

export default LineName;